<template>
  <aw-contact-us :contacts="contacts" :bordered="isOnWhiteCard" @promotion-interaction="onPromotionInteraction" />
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import AwContactUs from '~~/common/components/AwContactUs';
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin';
  import { sendBannerInteractionAnalytics, createThrottledSendBannerViewInteraction } from '~~/common/utils/bannerInteractionAnalytics';
  import cmsPageComponentMixin from '~~/common/mixins/cmsPageComponentMixin.js';
  import { AnalyticsBannerInteraction } from '~~/common/utils/AnalyticsBannerInteraction';

  defineOptions({
    inheritAttrs: false,
  });

  const props = defineProps({
    ...cmsPageComponentMixin.props,
    ...analyticsBannerInteractionMixin.props,
  });

  const { $awt } = useNuxtApp();

  const contacts = ref([
    {
      icon: 'mailbox-24',
      title: $awt('aw.cms.contact_us.email.title'),
      href: `mailto:${$awt('aw.global.contact_email')}`,
      label: $awt('aw.global.contact_email'),
    },
    {
      icon: 'answer-machine-24',
      title: $awt('aw.cms.contact_us.phone.title'),
      href: `tel:${$awt('aw.global.contact_phone')}`,
      label: $awt('aw.global.contact_phone_visible'),
    },
  ]);

  const extendedInteraction = computed(() => {
    return AnalyticsBannerInteraction.create({
      ...props.analyticsBannerInteraction,
      promotionName: $awt('aw.cms.contact_us.analytics.promotion_name'),
    });
  });

  onMounted(() => {
    createThrottledSendBannerViewInteraction()({
      analyticsMeasurable: props.analyticsMeasurable,
      analyticsBannerInteraction: extendedInteraction.value,
    });
  });

  function onPromotionInteraction () {
    sendBannerInteractionAnalytics({
      analyticsMeasurable: props.analyticsMeasurable,
      analyticsBannerInteraction: extendedInteraction.value,
    });
  }
</script>
